import { Router } from '@angular/router';
import { environment } from './../../../../environments/environment.staging';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HomeFooterComponent } from '../home-footer/home-footer.component';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-landing-download-apps',
  templateUrl: './landing-download-apps.component.html',
  styleUrls: ['./landing-download-apps.component.scss'],
  standalone: true,
  imports: [HomeFooterComponent, TranslateModule, NgOptimizedImage]
})
export class LandingDownloadAppsComponent implements OnInit {

  public appStoreUrl: string = environment.appStore;
  public googlePlayUrl: string = environment.googlePlay;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  public goBack(): void {
    this.router.navigate(['/']);
  }

}
